import React from 'react';

import { Box } from '@mui/material';

import logoHUDigital from '../../../../assets/logo/logoHUDigital.svg';
import logoAGHUX from '../../../../assets/logo/logoAghux.svg';

import './Header.css';

export function Header() {
  return (
    <Box
      display="flex"
      flexDirection="row"
      width="100%"
      height="10vh"
      alignItems="center"
      justifyContent="space-between"
    >
      <img className="logoHudigital" src={logoHUDigital} alt="logo hudigital" />
      <img className="logoAghux" src={logoAGHUX} alt="logo aghux" />
    </Box>
  );
}
